import { Switch, Redirect, Route, useLocation } from 'react-router';
import { ThemeProvider } from '@material-ui/core/styles';
import { createVseTheme } from 'vse-material-ui';
import { Layout } from './components/layout/Layout';
import { Home } from './components/Home';
import { LoginPage } from './components/login/LoginPage';
import { LogoutPage } from './components/login/LogoutPage';
import { ForgotPasswordPage } from './components/password/ForgotPasswordPage';
import { ResetPasswordPage } from './components/password/ResetPasswordPage';
import { RegisterPage } from './components/register/RegisterPage'; // VSE0004
import { ConfirmEmailPage } from './components/register/ConfirmEmailPage'; // VSE0004
import { NewApplPage } from './components/appl/NewApplPage';
import { MyApplPage } from './components/appl/MyApplPage';
import { Disclaimer } from './components/Disclaimer';
import { Timeout } from './components/Timeout';
import * as VseSession from './features/session';

let theme = createVseTheme();

export default function App() {
  const sessionState = VseSession.useVseSessionState();
  const location = useLocation();

  function secured(e: JSX.Element) {
    const link: string = `${location.pathname}${location.search}`;
    if (sessionState.token) {
      if (sessionState.token.isAuthenticated) {
        if (sessionState.loading === 'timeout') {
          return <Redirect to={`/timeout?redirect=${link}`} />;
        }
        else {
          return e;
        }
      }
    }
    return <Redirect to={`/login?redirect=${link}`} />;
  }

  const SecuredMyApplPage = () => (secured(<MyApplPage />));

  const SecuredNewApplPage = (props: any) => (secured(<NewApplPage {...props} />));
    
  return (
    <ThemeProvider theme={theme}>
      <Layout>
        <Switch>
          <Route exact path='/' component={Home} />
          <Route exact path='/login' component={LoginPage} />
          <Route exact path='/logout' component={LogoutPage} />
          <Route exact path='/create-account' component={RegisterPage} />
          <Route exact path='/activate-account' component={ConfirmEmailPage} />
          <Route exact path='/reset-password' component={ForgotPasswordPage} />
          <Route path='/reset-password/:id' component={ResetPasswordPage} />
          <Route exact path='/home' component={SecuredMyApplPage} />
          <Route path='/apply/:seasonID' component={SecuredNewApplPage} />
          <Route exact path='/disclaimer' component={Disclaimer} />
          <Route exact path='/timeout' component={Timeout} />
        </Switch>
      </Layout>
    </ThemeProvider>
  );
}
